<template>
  <div class="lock" v-if="isShow" @click="close">
    <div class="menu" @click.stop>
      <div class="close" @click.stop="close">关闭</div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
  },
  data() {
    return {
      isShow: false,
    }
  },
  created(){
    this.show();
  },
  methods:{
    show(){
      this.isShow=true;
      document.body.style.overflow="hidden";
    },
    close(){
      this.isShow=false;
      document.body.style.overflow="auto";
    }
  }
}
</script>
<style lang="less" scoped>
.lock {
  position: fixed;
  z-index: 1000;
  background-color: rgba(0,0,0,0.5);
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  padding: 0px 27rem;
}

.menu{
  font-size: 0px;
  margin: 0 auto;
  width: 50%;
  overflow-y: auto;
  .close{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/menu.vue